export const MelectronicsTheme = {
  name: 'Melectronics Theme',
  themeId: 'melectronics',
  colors: {
    brand: {
      primary: {
        100: '#F60'
      },
      secondary: {
        100: '#CE5200'
      },
      accent: {
        100: '#163D82'
      },
      negative: {
        100: '#bc0e35'
      },
      positive: {
        100: '#09845e'
      },
      alternative: {
        100: '#163d82'
      },
      specialRialtoRatingsColor: {
        100: '#333333'
      },
      specialRialtoElementsColor: {
        100: '#333333'
      }
    }
  },
  backgrounds: {
    tile: '#163d82'
  },
  fonts: {
    families: {
      text: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      condensed: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      heading: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      subHeading: '"Helvetica Neue Condensed", "Helvetica Neue", "Helvetica", Arial, sans-serif',
      display: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleText: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif',
      articleHeading: '"Helvetica Neue Std", "Helvetica Neue", Arial, sans-serif'
    },
    sizes: {
      text: {
        tiny: '10px',
        xsmall: '12px',
        small: '14px',
        medium: '16px',
        large: '18px',
        xlarge: '22px',
        huge: '26px'
      },
      heading: {
        tiny: '14px',
        xsmall: '18px',
        small: '22px',
        medium: '26px',
        large: '32px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  }
};